import { NgClass } from '@angular/common';
import { Component, Input, output, input, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { BaseTooltipComponent } from '@core/product-updates-smart-ui';
import { TellentBrand } from '@core/tellent-types';
import {
  BadgeComponent,
  ButtonComponent,
  IconButtonComponent,
  IconComponent,
  PreventOrphansPipe,
} from '@core/user-interface-legacy';
import { ArrowPosition } from '@core/user-interface-types';

@Component({
  selector: 'rt-feature-tooltip',
  templateUrl: './feature-tooltip.component.html',
  styleUrls: ['./feature-tooltip.component.less'],
  imports: [
    NgClass,
    BadgeComponent,
    IconButtonComponent,
    ButtonComponent,
    TranslatePipe,
    PreventOrphansPipe,
    IconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class]': 'brand()',
  },
})
export class FeatureTooltipComponent extends BaseTooltipComponent {
  public readonly TellentBrand = TellentBrand;

  public readonly title = input<string>(undefined!);
  public readonly description = input<string>(undefined!);
  public readonly ctaText = input<string>();
  public readonly ctaPosition = input<'left' | 'right'>();
  public readonly ctaHasChevron = input<boolean>();
  public readonly learnMoreAsButton = input<boolean>();
  public readonly learnMoreCopy = input<string>();
  public readonly brand = input<TellentBrand | undefined>(TellentBrand.Recruitee);

  @Input() public isNew: boolean;
  @Input() public learnMore?: string;
  @Input() public badgeCopy?: string;
  @Input() public arrowPosition: ArrowPosition;

  public learnMoreClick = output<void>();
  public ctaClick = output<void>();
  public close = output<void>();

  public ngOnChanges(): void {
    this.updateArrow(this.arrowPosition);
  }
}
